export default [
  {
    inputs: [
      {
        internalType: "contract ISablierV2Archive",
        name: "archive_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "CallNotDelegateCall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "SablierV2ProxyPlugin_UnknownCaller",
    type: "error",
  },
  {
    inputs: [],
    name: "archive",
    outputs: [
      {
        internalType: "contract ISablierV2Archive",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMethods",
    outputs: [
      {
        internalType: "bytes4[]",
        name: "methods",
        type: "bytes4[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "streamId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "senderAmount",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    name: "onStreamCanceled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;
